export default __webpack_public_path__ + "static/media/Steamind.91974304.png";